export type LoopKind = "shimmer" | "spin" | "marquee";

// Periods in ms; marquee speed in px/s.
export const loops = {
  shimmer: { period: 1640 },
  spin: { period: 1000 },
  marquee: { speed: 28 },
} as const;

export const loopPeriodMs = (kind: LoopKind, lap = 0) =>
  kind === "marquee" ? (lap / loops.marquee.speed) * 1000 : loops[kind].period;

export type LoopGeometry = { lap?: number; reverse?: boolean; width?: number };

/** Degrees for spin, px otherwise. */
export const loopPosition = (
  kind: LoopKind,
  progress: number,
  { lap = 0, reverse = false, width = 0 }: LoopGeometry,
) => {
  "worklet";
  if (kind === "spin") {
    return progress * 360;
  }
  if (kind === "marquee") {
    return (reverse ? progress - 1 : -progress) * lap;
  }
  return (progress * 2 - 1) * width;
};

const KINDS: readonly LoopKind[] = ["shimmer", "spin", "marquee"];

// A box shimmer moves on the compositor; text has to animate its background for the clip.
// Rest frames sit off the box so reduced motion shows nothing.
export const loopsCss = [
  "@keyframes loop-shimmer{from{transform:translateX(-100%)}to{transform:translateX(100%)}}",
  "@keyframes loop-shimmer-text{from{background-position:-100% 0}to{background-position:200% 0}}",
  "@keyframes loop-spin{to{transform:rotate(360deg)}}",
  "@keyframes loop-marquee{to{transform:translateX(var(--loop-lap))}}",
  `.loop-shimmer{animation:loop-shimmer ${loops.shimmer.period}ms ease-in-out infinite;transform:translateX(-100%)}`,
  `.loop-shimmer-text{animation:loop-shimmer-text ${loops.shimmer.period}ms ease-in-out infinite;background-size:50% 100%;background-repeat:no-repeat;background-position:-100% 0}`,
  `.loop-spin{animation:loop-spin ${loops.spin.period}ms linear infinite;display:flex}`,
  ".loop-marquee{animation:loop-marquee var(--loop-period) linear infinite}",
  `@media (prefers-reduced-motion:reduce){${[...KINDS, "shimmer-text"].map(kind => `.loop-${kind}`).join(",")}{animation:none}}`,
].join("\n");
